import React, { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import { Snackbar, Alert } from "@mui/material";

import { Building, Calendar, Printer, RefreshCw, Download } from "lucide-react";
import { Tooltip } from "@mui/material";

import axios from "axios";
import Modal from "../../common/CommonModal";
import ProductListing from "../../salesInvoice/ProductsModal";
import useApi from "../../../hooks/useApi";
import StockLedgerPrint from "./StockLedgerPrint";

const StockLedger = ({ issueStoreAccounts }) => {
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  const { request } = useApi();
  const newDate = new Date();
  const today = newDate.toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(today);

  const [toDate, setToDate] = useState(today);
  const [stockLedgerList, setStockLedgerList] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [codeModalOpen, setCodeModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [searchBy, setSearchBy] = useState("UNIVERSAL");
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const [codeFrom, setCodeFrom] = useState("");
  const [codeTo, setCodeTo] = useState("");

  const [group, setGroup] = useState("");
  const [subGroup, setSubGroup] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [location, setLocation] = useState("");

  const [groupList, setGroupList] = useState([]);
  const [subGroupList, setSubGroupList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [locationList, setLocationList] = useState([]);

  const [includeWZChecked, setIncludeWZChecked] = useState(false);
  const [includeWCChecked, setIncludeWCChecked] = useState(false);
  const [isPrintDisabled, setIsPrintDisabled] = useState(true);

  const [stockLedgerPrint, setStockLedgerPrint] = useState(false);

  useEffect(() => {
    fetchCompanyInfo();
    fetchLocations();
    fetchMasterList("GROUP", setGroupList);
    fetchMasterList("SUBGROUP", setSubGroupList);
    fetchMasterList("CATEGORY", setCategoryList);
    fetchMasterList("SUBCATEGORY", setSubCategoryList);
  }, []);
  const isApplyDisabled = !codeFrom?.trim() || !codeTo?.trim();

  useEffect(() => {
    if (codeFrom !== "") {
      setCodeTo(codeFrom);
    }
  }, [codeFrom]);

  const fetchCompanyInfo = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/COMPANYINFO/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      const companyInfoData = data[0];
      console.log("companyInfoData :", companyInfoData);
      setFromDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    }
  };

  const fetchMasterList = async (type, setter) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    // let url = `${apiPaths[0]?.API_CONFIG}/api/MasterCount/${companyCode}/GROUP/-/-`;
    let url = `${apiPaths[0]?.API_CONFIG}/api/MasterCount/${COMPANY_CODE}/${type}/-/-`;

    try {
      const response = await axios.get(url);
      console.log("responseeee:", response.data);
      setter(response.data || []);
    } catch (err) {
      console.error("Error while loading Voucher Type List:", err);
    }
  };
  const fetchLocations = async () => {
    try {
      let department = localStorage.getItem("currentSelectedDepartment") || "-";
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/LOCATONLIST_ALL/${department}/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      // console.log("Location List:", data);
      setLocationList(data);
    } catch (error) {
      console.error("Error while fetching location list!", error);
    }
  };

  const fetchStockLedgerList = async (drAcc) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let url = `${
      apiPaths[0]?.API_CONFIG
    }/api/CRMStockLedger/${COMPANY_CODE}/STOCKLEDGER/${codeFrom.trim()}/${codeTo.trim()}/${fromDate}/${toDate}/${
      group?.trim() ? group.trim() : "-"
    }/${subGroup?.trim() ? subGroup.trim() : "-"}/${
      category?.trim() ? category.trim() : "-"
    }/${subCategory?.trim() ? subCategory.trim() : "-"}/${
      location?.trim() ? location.trim() : "-"
    }/${includeWZChecked ? "Y" : "N"}/${includeWCChecked ? "Y" : "N"}`;

    try {
      setLoading(true);
      const response = await axios.get(url);
      const data = response.data;

      console.log("response data in stock ledger:", data);

      setStockLedgerList(data || []);
    } catch (err) {
      console.error("Error while loading stock ledger:", err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (stockLedgerList.length !== 0) {
  //     setIsPrintDisabled(false);
  //   }
  // }, [stockLedgerList]);

  useEffect(() => {
    setIsPrintDisabled(stockLedgerList.length === 0);
  }, [stockLedgerList]);

  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  const BASE_URL = apiPaths_from_local_storage[0].API_CONFIG;
  const fetchProductData = useCallback(
    async (query, searchByValue, location = "A") => {
      const effectiveQuery = query?.trim() === "" ? "-" : query?.trim() || "-";
      const formattedQuery = effectiveQuery.replace(/\//g, "%2F");

      try {
        if (!loading) setLoading(true);
        const url = `${BASE_URL}/api/CRMStockList/${COMPANY_CODE}/${searchByValue}/${formattedQuery}/${location}/-`;
        const response = await request({
          url: url,
          method: "GET",
          timeout: 5000,
        });
        if (response) {
          setProducts(response);
        } else {
          setProducts([]);
        }
      } catch (err) {
        console.error("Failed to fetch product data", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL, COMPANY_CODE],
  );
  useEffect(() => {
    if (!searchQuery && searchBy === "UNIVERSAL") return;
    fetchProductData(searchQuery, searchBy);
  }, [searchQuery, searchBy, fetchProductData]);

  const handleProductSelect = (product) => {
    console.log("Selected Product:", product);
    setCodeModalOpen(false);
    if (activeRowIndex === null) return;

    if (activeRowIndex === 1) {
      setCodeFrom(product.id || "-");
    } else if (activeRowIndex === 2) {
      setCodeTo(product.id || "-");
    }

    setActiveRowIndex(null);
  };

  const handleIncludeWZChange = (e) => {
    setIncludeWZChecked(e.target.checked);
  };

  const handleIncludeWCChange = (e) => {
    setIncludeWCChecked(e.target.checked);
  };

  const totalQtyReceived = stockLedgerList?.reduce(
    (acc, row) => acc + Number(row.QTY_RCVD || 0),
    0,
  );

  const totalQtyIssued = stockLedgerList?.reduce(
    (acc, row) => acc + Number(row.QTY_ISSD || 0),
    0,
  );

  // const balanceQty = totalQtyReceived - totalQtyIssued;

  // useEffect(()=>{
  //   console.log('group:',group)
  //   console.log('subGroup:',subGroup)
  //   console.log('category:',category)
  //   console.log('subCategory:',subCategory)
  //   console.log('location:',location)
  // },[group,subGroup,category,subCategory,location])

  const handleExport = () => {
    if (!stockLedgerList || stockLedgerList.length === 0) {
      alert("No data to export");
      return;
    }

    const columns = [
      { field: "CODE", headerName: "Code" },
      { field: "DESCRIPTION", headerName: "Description" },
      { field: "CUSTOMER", headerName: "Customer" },
      { field: "DATE", headerName: "Date" },
      { field: "DEPT", headerName: "Department" },
      { field: "INV", headerName: "Invoice" },
      { field: "PRICE", headerName: "Price" },
      { field: "QTY_ISSD", headerName: "Quantity Issued" },
      { field: "QTY_RCVD", headerName: "Quantity Received" },
      { field: "SALESMAN", headerName: "Salesman" },
      { field: "TYPE", headerName: "Type" },
    ];

    exportToCSV(columns, stockLedgerList, "Stock_Ledger_List");
  };

  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    // Create header row
    const headerRow = columns.map((col) => col.headerName);

    // Create data rows
    const dataRows = exportData?.map((row) =>
      columns.map((col) => {
        let value = row[col.field] ?? "";

        // Special formatting for date
        if (col.field === "CHQDATE" && value) {
          value = dayjs(value).format("DD/MM/YYYY");
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      }),
    );

    // Combine header + data
    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex justify-center items-start">
      <div className="w-[25vw] h-[70vh]  bg-white shadow-md border-r border-gray-200 p-3 space-y-5">
        <div className="space-y-8">
          {/* Dr A/C */}
          <div className="flex justify-left items-center gap-1 ">
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                {/* <ArrowDownLeft className="w-4 h-4 mr-2 text-gray-600" /> */}
                Code From
              </label>
              <input
                readOnly
                value={codeFrom}
                onChange={(e) => setCodeFrom(e.target.value)}
                placeholder="Press F2 to choose code"
                className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                   placeholder-gray-400 transition-all duration-200 bg-gray-100"
                onKeyDown={(e) => {
                  if (e.key === "F2") {
                    setActiveRowIndex(1);
                    setCodeModalOpen(true);
                  }
                }}
              />
            </div>
            {/* PDC Account */}
            <Tooltip title={codeTo} arrow>
              <div className="flex-1">
                <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                  Code To
                </label>
                <input
                  readOnly
                  value={codeTo}
                  placeholder="Press F2 to choose code"
                  className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                   placeholder-gray-400 transition-all duration-200"
                  onKeyDown={(e) => {
                    if (e.key === "F2") {
                      setActiveRowIndex(2);
                      setCodeModalOpen(true);
                    }
                  }}
                />
              </div>
            </Tooltip>
          </div>

          {/* Cr A/C */}
          <div className="flex justify-center items-center gap-1 ">
            {/* <div className="">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <ArrowUpRight className="w-4 h-4 mr-2 text-gray-600" />
                Bank
              </label>
              <input
                value={crAccount}
                onChange={(e) => setCrAccount(e.target.value)}
                placeholder="Enter Cr A/C..."
                className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-purple-500 
                   placeholder-gray-400 transition-all duration-200"
              />
            </div> */}
            <div className=" w-full">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                From Date
              </label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                   transition-all duration-200"
              />
            </div>

            <div className="w-full">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                To Date
              </label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                   transition-all duration-200"
              />
            </div>
          </div>

          {/* Manage Opening PDC Button */}
          {/* <div className="py-2">
            <button
              onClick={() => setOpenPDC(true)}
              className="w-full flex items-center justify-center gap-2 
               bg-purple-500 
               text-white font-semibold py-2.5 px-4 
               rounded-xl shadow-md hover:shadow-lg 
               hover:from-purple-600 hover:to-purple-700
               active:scale-95 transition-all duration-200
               focus:outline-none focus:ring-2 focus:ring-purple-300 text-sm"
            >
              <CheckCircle className="w-5 h-5 text-white" />
              Manage Opening PDC
            </button>
          </div> */}

          <div className="flex items-center ">
            <div className="flex items-center w-full">
              <label className="text-xs font-semibold mr-2">
                Qty Without Zero Qty
              </label>

              <input
                type="checkbox"
                className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                name="includeWZ"
                checked={includeWZChecked}
                onChange={handleIncludeWZChange}
              />
            </div>

            <div className="flex items-center  w-full">
              <label className="text-xs font-semibold mr-2">
                With Cost Details
              </label>

              <input
                type="checkbox"
                className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                name="includeWC"
                checked={includeWCChecked}
                onChange={handleIncludeWCChange}
              />
            </div>
          </div>

          <div className="flex-1">
            <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
              {/* <Building className="w-4 h-4 mr-2 text-gray-600" /> */}
              Location
            </label>
            <select
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
            >
              <option value="">Select Location...</option>
              {locationList.map((item, index) => (
                <option key={index} value={item.loc_code}>
                  {item.DESC}
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-left items-center gap-1 ">
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Building className="w-4 h-4 mr-2 text-gray-600" />
                Group
              </label>
              <select
                value={group}
                onChange={(e) => setGroup(e.target.value)}
                className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
              >
                <option value="">Select Group...</option>
                {groupList?.map((group, index) => (
                  <option key={index} value={group["GRP CODE"]}>
                    {group.DESCRIPTION}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Building className="w-4 h-4 mr-2 text-gray-600" />
                Sub Group
              </label>
              <select
                value={subGroup}
                onChange={(e) => setSubGroup(e.target.value)}
                className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
              >
                <option value="">Select Sub Group...</option>
                {subGroupList?.map((group, index) => (
                  <option key={index} value={group["GRP CODE"]}>
                    {group.DESCRIPTION}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-left items-center gap-1 ">
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Building className="w-4 h-4 mr-2 text-gray-600" />
                Category
              </label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
              >
                <option value="">Select Category...</option>
                {categoryList?.map((group, index) => (
                  <option key={index} value={group["GRP CODE"]}>
                    {group.DESCRIPTION}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Building className="w-4 h-4 mr-2 text-gray-600" />
                Sub Category
              </label>
              <select
                value={subCategory}
                onChange={(e) => setSubCategory(e.target.value)}
                className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
              >
                <option value="">Select Sub Category...</option>
                {subCategoryList?.map((group, index) => (
                  <option key={index} value={group["GRP CODE"]}>
                    {group.DESCRIPTION}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex gap-3 py-2">
            <button
              onClick={fetchStockLedgerList}
              disabled={isApplyDisabled || loading}
              className={`flex-1 flex items-center justify-center gap-2 
    font-medium px-4 py-2.5 rounded-lg text-sm
    transition-all duration-200
    ${
      isApplyDisabled || loading
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-indigo-500 text-white shadow hover:shadow-md hover:scale-[1.02] active:scale-100"
    }`}
            >
              <RefreshCw className="w-4 h-4" />
              {loading ? "Loading..." : "Apply"}
            </button>

            {/* <button
              onClick={() => setStockLedgerPrint(true)}
              disabled={isPrintDisabled}
              className={`flex-1 flex items-center justify-center gap-2 
    font-medium px-4 py-2.5 rounded-lg text-sm
    transition-all duration-200
    ${
      isPrintDisabled
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-teal-500 text-white shadow hover:shadow-md hover:scale-[1.02] active:scale-100"
    }`}
            >
              <Printer className="w-4 h-4" />
              Print


            </button> */}

            <button
              onClick={handleExport}
              className="flex-1 flex items-center justify-center gap-2 
                                     bg-cyan-600 text-white 
                                     font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                                     transform hover:scale-[1.02] active:scale-100 
                                     transition-all duration-200 text-sm"
            >
              <Download className="w-4 h-4" />
              Export
            </button>
          </div>
        </div>
      </div>

      <div className="w-[1200px] overflow-auto h-[70vh] shadow-md  scrollbar-auto-hide relative">
        <div className="w-[70vw]">
          {loading && (
            <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/60 backdrop-blur-sm">
              <div className="flex flex-col items-center gap-2">
                <div className="h-10 w-10 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
                <span className="text-xs text-gray-600 font-medium">
                  Loading stock ledger...
                </span>
              </div>
            </div>
          )}
          <table className="  text-xs border-collapse">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 z-10">
                  DEPT
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  TYPE
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  DATE
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  INV
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  CUSTOMER
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  CODE
                </th>

                <th className="bg-gray-100 w-60 font-normal sticky top-0 border px-2 py-1">
                  DESCRIPTION
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  QTY RCVD
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  QTY ISSD
                </th>
                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  PRICE
                </th>

                <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
                  SALESMAN
                </th>
              </tr>
            </thead>
            <tbody>
              {stockLedgerList?.length > 0 ? (
                stockLedgerList.map((acc, index) => (
                  <tr key={acc?.INV || index} className="text-xs">
                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.DEPT ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-right">
                      {acc?.TYPE ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.DATE ? dayjs(acc.DATE).format("DD/MM/YYYY") : "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-left">
                      {acc?.INV ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.CUSTOMER ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-left">
                      {acc?.CODE ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center text-xs">
                      {acc?.DESCRIPTION ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.QTY_RCVD ?? "-"}
                    </td>
                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.QTY_ISSD ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.PRICE ?? "-"}
                    </td>

                    <td className="border bg-white px-2 py-1 text-center">
                      {acc?.SALESMAN ?? "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9} className="text-center py-4 text-gray-500">
                    {/* No outstanding data available */}
                  </td>
                </tr>
              )}
              {stockLedgerList?.length > 0 ? (
                <tr className="bg-gray-100 sticky bottom-0 z-10 pb-4">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-sm w-40 px-1 pb-4 text-right">
                    <span className="text-xs">Total QTY_RCVD : </span>
                    <span className="text-xs font-semibold">
                      {totalQtyReceived.toFixed(2)}
                    </span>
                  </td>

                  <td className="text-sm w-40 px-2 pb-4 text-right">
                    <span className="text-xs">Total QTY_ISSD : </span>
                    <span className="text-xs font-semibold">
                      {totalQtyIssued.toFixed(2)}
                    </span>
                  </td>

                  <td className="text-sm w-40 px-1 py-1 text-right">
                    <span className="text-xs">Balance : </span>
                    <span className="font-semibold">
                      {(totalQtyReceived - totalQtyIssued).toFixed(2)}
                      {/* {balanceQty.toFixed(2)} */}
                    </span>
                  </td>
                  <td></td>
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
          {!loading && stockLedgerList.length === 0 && (
            <div className="flex items-center justify-center h-full text-gray-500 text-sm mt-60">
              No stock ledger data found
            </div>
          )}
        </div>
      </div>
      {/* {openPDC && <PDCOpenPopup setOpenPDC={setOpenPDC} data={"12040036"} />}
      {pdcDrModalOpen && <PDCF2Popup setPdcDrModalOpen={setPdcDrModalOpen}  accounts={accountsF2}/>} */}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>

      {stockLedgerPrint && (
        <div className="m-6">
          <StockLedgerPrint
            pdcIssuedPrintDataFromAPI={stockLedgerList}
            setStockLedgerPrint={setStockLedgerPrint}
            isStockLedgerPrint={stockLedgerPrint}
          />
        </div>
      )}

      {codeModalOpen && (
        <Modal
          isOpen={codeModalOpen}
          onClose={() => setCodeModalOpen(false)}
          title={"Select Item Code"}
          size="xxl"
          header={true}
        >
          <ProductListing
            modalSuggestions={products}
            loading={loading}
            searchBy={searchBy}
            setSearchBy={setSearchBy}
            onSearchQueryChange={setSearchQuery}
            handleProductSelect={handleProductSelect}
          />
        </Modal>
      )}
    </div>
  );
};

export default StockLedger;
